import React from "react";
import { compose } from "redux";
import { Grid, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import HeliReportRow from "features/planner/report/helicopter/components/HeliReportRow";

const HeliReportInboundOutboundRow = ({ classes, children }) => (
  <HeliReportRow>
    <Grid
      container
      justifyContent="center"
      className={classes.inBoundOutBoundColumn}
    >
      <Typography className={classes.inBoundOutBoundText}>
        {children}
      </Typography>
    </Grid>
  </HeliReportRow>
);

const styles = theme => ({
  inBoundOutBoundText: {
    fontWeight: theme.typography.fontWeightMedium,
  },
  inBoundOutBoundColumn: {
    padding: theme.spacing(1),
  },
});

export default compose(withStyles(styles))(HeliReportInboundOutboundRow);
